import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// The module loads on first visit as one section; its screens split further inside it (MedspaSection.tsx)
const MedspaSection = lazyRoute(() => import('./MedspaSection').then((m) => m.MedspaSection));
const RebookPage = lazyRoute(() => import('./public/RebookPage').then((m) => m.RebookPage));
const MenuBookingPage = lazyRoute(() => import('./public/MenuBookingPage').then((m) => m.MenuBookingPage));

/** Med spa (visits, treatments, packages, clients, rebooking, reports, settings), under /agencies/:agencyId/medspa */
export const medspaAgencyRoutes = <Route path="medspa/*" element={<MedspaSection />} />;

/** Client-facing (no sign-in): the one-tap rebook link and the treatment menu booking page */
export const medspaPublicRoutes = (
  <>
    <Route path="/rebook" element={<RebookPage />} />
    <Route path="/book/:pageSlug/treatments" element={<MenuBookingPage />} />
  </>
);
